import { useCallback, useEffect, useState } from "react";
import { getValue } from "../../../shared/scripts";

export const BonTable = ({
    formId,
    renderToolBar,
    renderHeader,
    renderNotation,
    renderTools,
    children,
    className,
    style = {
        width: '100%',
        marginLeft: '2px'
    },
}) => {
    return (
        <div style={style}>
            {renderToolBar != null && renderToolBar()}
            <form id={formId}>
                {renderTools != null && renderTools()}
                <table
                    style={{ marginBottom: '25px' }}
                    className={className == null ? "global-table" : className}
                >
                    <tbody>
                        {renderHeader != null && renderHeader()}
                        {
                            children
                        }
                    </tbody>
                </table>
                {renderNotation != null && renderNotation()}
            </form>
        </div>
    );
}

BonTable.Cell = ({
    children,
    rowSpan = 1,
    colSpan = 1,
    className = '',
    tooltip = null,
    style = {
        height: "31px",
    },
    onClick = null,
}) => (
    <td
        rowSpan={rowSpan}
        colSpan={colSpan}
        style={style}
        className={className}
        title={tooltip}
        onClick={onClick}
    >
        {
            children
        }
    </td>
);

export const BonTableCellText = ({
    name,
    onChange,
    value = null,
    placeholder = "-",
    readOnly = false,
    required = true,
    pattern = null,
    rowSpan = 1,
    colSpan = 1,
    cellStyle = { height: '31px' },
    cellClassName = '',
    inputClassName = 'title-input',
    nullable = false,
}) => {
    return (
        <BonTable.Cell
            rowSpan={rowSpan}
            colSpan={colSpan}
            style={cellStyle}
            className={cellClassName}
        >
            <CellTextInput
                name={name}
                value={value}
                onChange={str => onChange(str)}
                placeholder={placeholder}
                readOnly={readOnly}
                required={nullable && value == null ? false : required}
                pattern={pattern}
                className={inputClassName}
            />
        </BonTable.Cell>
    )
}

const CellTextInput = ({
    name,
    value = null,
    onChange = null,
    placeholder = "-",
    className = '',
    nullable = false,
    required = true,
    readOnly = false,
    pattern = null,
}) => {

    const [isFirstEventFired, setIsFirstEventFired] = useState(false);
    const [innerValue, setInnerValue] = useState(value == null ? '' : value);

    useEffect(() => {
        setInnerValue(value == null ? '' : value);
    }, [value]);

    const hahdleChange = useCallback(event => {
        const str = getValue.String(event);
        setInnerValue(str);

        if (!isFirstEventFired) {
            setIsFirstEventFired(true);

            if (onChange != null) {
                onChange(str);
            }
        }
    }, [isFirstEventFired, onChange]);

    const handleFocusLost = useCallback(() => {
        if (!isFirstEventFired) {
            return;
        }

        if (onChange != null) {
            onChange(nullable && innerValue === '' ? null : innerValue);
        }

        setIsFirstEventFired(false);
    }, [innerValue, isFirstEventFired, onChange, nullable]);

    return (
        <input
            className={className}
            type="text"
            onChange={hahdleChange}
            onBlur={handleFocusLost}
            name={name}
            value={innerValue}
            placeholder={placeholder}
            required={nullable && value == null ? false : required}
            readOnly={readOnly}
            pattern={pattern}
            spellCheck='false'
            autoComplete='off'
        />
    )
};
